// src/features/auth/types.ts

/**
 * Permission levels from backend
 */
export enum PermissionLevel {
  VIEW = 'view',
  EDIT = 'edit',
  NONE = 'none',
}

/**
 * Permission structure from backend API
 */
export interface Permission {
  id: string;
  roleId: string;
  resourceId: string;
  resourceName?: string; // Resource name/path (e.g., "/home") - included when using optimized endpoint
  permission: PermissionLevel;
  status: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  roleId?: string; // Optional: If backend includes roleId in JWT
  accountId: string;
  allowedAccountIds?: string[]; // Optional: Array of account IDs user has access to
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
  loading: boolean;
  error: string | null;
  permissions: Permission[];
}

export type AuthAction =
  | { type: 'AUTH_INIT' }
  | { type: 'LOGIN_SUCCESS'; payload: { user: User; token: string } }
  | { type: 'PERMISSIONS_LOADED'; payload: Permission[] }
  | { type: 'AUTH_ERROR'; payload: string | null }
  | { type: 'LOGOUT' };

export interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials) => Promise<boolean>;
  logout: () => void;
  hasPermission: (resourceId: string, requiredLevel?: PermissionLevel) => boolean;
} 